export const entra = {
  clientId: "41d075e2-6c98-491c-b4fd-0109bee11d0c",
  tenantId: "b1d2c31b-16f1-4682-abf3-b29148950d8a",
  scope: "api://41d075e2-6c98-491c-b4fd-0109bee11d0c/access_as_ops",
};
